import React from 'react';

import Popover from '@material-ui/core/Popover';

import useStyles from './styles';
import { getDateTime, getValue } from '../../helpers';
// import { getDateTime, getItemValue, getValue } from '../../helpers';
import CustomPopoverTypography from '../../custom/popovertypography';

export default function CustomPopover({ ...props }) {
  const classes = useStyles();

  const data = [
    { key: 'name', title: 'Nome', value: getValue(props.data, 'name', '') },
    { key: 'user.name', title: 'Nome', value: getValue(props.data, 'user.name', '') },

    { key: 'email', title: 'Email', value: getValue(props.data, 'email', '') },
    { key: 'user.email', title: 'Email', value: getValue(props.data, 'user.email', '') },

    { key: 'profile.name', title: 'Perfil', value: getValue(props.data, 'profile.name', '') },

    { key: 'placa', title: 'Placa', value: getValue(props.data, 'placa', '') },
    { key: 'user.placa', title: 'Placa', value: getValue(props.data, 'user.placa', '') },

    { key: 'from_account_name', title: 'Nome origem', value: getValue(props.data, 'from_account_name', '') },
    { key: 'from_account_email', title: 'Email origem', value: getValue(props.data, 'from_account_email', '') },
    { key: 'from_account_id', title: 'Conta origem', value: getValue(props.data, 'from_account_id', '') },

    { key: 'to_account_name', title: 'Nome destino', value: getValue(props.data, 'to_account_name', '') },
    { key: 'to_account_email', title: 'Email destino', value: getValue(props.data, 'to_account_email', '') },
    { key: 'to_account_id', title: 'Conta destino', value: getValue(props.data, 'to_account_id', '') },

    { key: 'owners_name', title: 'Nome responsável', value: getValue(props.data, 'owners_name', '') },
    { key: 'owners_email', title: 'Email responsável', value: getValue(props.data, 'owners_email', '') },

    { key: 'created_at', title: 'Criado em', value: getDateTime(props.data, 'created_at', '') },
    // { key: 'user.created_at', title: 'Cliente desde', value: getDateTime(props.data, 'user.created_at', '') },
  ];

  return (
    <>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={props.open}
        anchorEl={props.item}
        anchorOrigin={props.anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={props.transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={props.onClose}
        disableRestoreFocus={true}
      >
      {
        props.data &&
        data.map((item) => {
          if (item.value && !(Array.isArray(props.filter) && props.filter.find(key => key === item.key))) {
            return <CustomPopoverTypography key={item.key} title={item.title}>{item.value}</CustomPopoverTypography>;
          }
          return '';
        })
      }
      </Popover>
    </>
  );
};
